// services/narration/renderPublicNarratives.ts
import type { AnalysisResult } from "../../types";
import type { EvidenceAtom, MetricId, TruthPayload } from "../../types";
import {
  capaciteMusicale,
  niveauAtteint,
  potentiel,
  diagnosticPedagogique,
} from "./templates.fr";

export function renderPublicNarratives(args: {
  result: AnalysisResult;
  facts: Record<MetricId, EvidenceAtom>;
}): TruthPayload["outputs"] {
  const { facts } = args;

  return {
    capacite_musicale: capaciteMusicale(facts),
    niveau_atteint: niveauAtteint(facts),
    potentiel: potentiel(facts),
    diagnostic_pedagogique: diagnosticPedagogique(facts),
  };
}
